import { render, staticRenderFns } from "./HospitalAdd.vue?vue&type=template&id=5bd19635&"
import script from "./HospitalAdd.vue?vue&type=script&lang=js&"
export * from "./HospitalAdd.vue?vue&type=script&lang=js&"
import style0 from "./HospitalAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports